import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  clearCart,
  resetSubmittingOrder,
  storeSuccessAndBuildOrder,
} from '../../../actions/v3Order';
import { clearCartVoucherItems } from '../../../actions/action_cart_voucher_items';
import OverlayLoader from '../utils/OverlayLoader';

const SuccessParagraph = styled.p`
  font-size: 16px;
  margin-top: 16px;
  font-weight: 600;
`;

const Checkout = (props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [orderId, setOrderId] = useState(null);
  const query = new URLSearchParams(props.location.search);
  const sessionId = query.get('session_id');
  const uuid = query.get('cart_uuid');

  useEffect(() => {
    // clear the cart immediately
    dispatch(clearCart());

    // reset the order-submitting state
    dispatch(resetSubmittingOrder());

    const fetchOrder = async () => {
      const result = await dispatch(storeSuccessAndBuildOrder(sessionId, uuid));

      // Clear voucher items AFTER order is built (voucher data is now stored in cart JSON)
      dispatch(clearCartVoucherItems(uuid));

      console.log('result', result);
      // setOrderId(result.orderId);
      setIsLoading(false);
    };

    fetchOrder();
  }, [sessionId]);

  return (
    <>
      {isLoading ? (
        <>
          <OverlayLoader />
          <div className="text-center">
            <h1>Submitting...</h1>
            <SuccessParagraph>Your order is submitting.</SuccessParagraph>
            <SuccessParagraph>
              Please do not close or refresh this page.
            </SuccessParagraph>
          </div>
        </>
      ) : (
        <div className="text-center">
          <h1>Success!</h1>
          <SuccessParagraph>Your order has been submitted.</SuccessParagraph>
          <SuccessParagraph>
            You will receive an email confirmation soon with your order details.
          </SuccessParagraph>
          <p style={{ marginTop: '16px' }}>
            <Link
              to="/dashboard"
              className="btn btn-primary"
              style={{
                marginTop: '8px',
                backgroundColor: '#479de6',
                border: 'none',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Back to Home
            </Link>
          </p>
        </div>
      )}
    </>
  );
};

export default Checkout;
